import { IRolAcceso } from "src/app/shared/models/item.model";

export class CRol implements IRolAcceso{
  rol:string='';
  acceso:string[]=[]
}
